import {HttpContext, HttpContextToken, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';

import {HttpShortHeaders, HttpShortParams} from './http-shorts';

export const HTTP_OPTION_KEYS = {
	appendToken: 'appendToken',
} as const;
export type HTTP_OPTION_KEYS = (typeof HTTP_OPTION_KEYS)[keyof typeof HTTP_OPTION_KEYS];

export type IHttpRequestConfig = Record<HTTP_OPTION_KEYS, boolean>;

export class HttpRequestConfig {
	static appendToken_ContextToken: HttpContextToken<boolean> = new HttpContextToken(() => undefined);
	/* -------------------------------------------------- */
	private readonly _httpHeaders: HttpHeaders;
	private readonly _params: HttpParams;

	constructor(
		private _httpShortHeaders: HttpShortHeaders,
		private _httpShortParams: HttpShortParams,
		private _appendToken = true,
	) {
		this._httpHeaders = _httpShortHeaders as HttpHeaders;
		if (!(_httpShortHeaders instanceof HttpHeaders)) {
			this._httpHeaders = new HttpHeaders(_httpShortHeaders);
		}

		this._params = _httpShortParams as HttpParams;
		if (!(_httpShortParams instanceof HttpParams)) {
			const jsonifyParams = JSON.parse(JSON.stringify(_httpShortParams));
			this._params = new HttpParams({fromObject: jsonifyParams});
		}
	}

	get httpConfig(): {headers: HttpHeaders; params: HttpParams; context: HttpContext} {
		const context: HttpContext = new HttpContext();
		/* ----------------  appendToken ---------------- */
		context.set(HttpRequestConfig.appendToken_ContextToken, this._appendToken);

		/* -------------------------------------------------------------------------------------------------------------- */
		return {
			headers: this._httpHeaders,
			params: this._params,
			context,
		};
	}

	public static getRequestConfig(req: HttpRequest<any>): IHttpRequestConfig {
		const context: HttpContext = req.context;
		return {
			[HTTP_OPTION_KEYS.appendToken]: context.get(HttpRequestConfig.appendToken_ContextToken),
		};
	}

	public static getPureRequest(req: HttpRequest<any>): HttpRequest<any> {
		// clear custom headers:
		req.context.delete(HttpRequestConfig.appendToken_ContextToken);
		return req;
	}
}
